import get from 'lodash.get';
import has from 'lodash.has';
import deepProxy from 'proxy-deep';

export default {
  methods: {
    $proxyModel(modelPath, isArray = false) {
      const { $set } = this;
      const model = () => get(this, `${modelPath}.$model`, !isArray ? {} : []);
      const validateModel = () => get(this, modelPath, {});

      return deepProxy(model(), {
        get(target, path, receiver) {
          if (typeof path !== 'symbol') {
            const attr = get(target, path);

            if (typeof attr !== 'function' && typeof attr === 'object' && attr !== null && path !== '__ob__') {
              return this.nest(attr);
            }
            return attr;
          }

          return Reflect.get(target, path, receiver);
        },
        set(target, path, val) {
          if (get(target, path) !== val) {
            const validationPath = [
              ...this.path.map(mapValidationPathParts),
              path,
            ].join('.');

            if (has(validateModel(), validationPath)) {
              const attr = get(validateModel(), validationPath);
              if (attr.$touch) {
                attr.$touch();
              }
            }


            $set(target, path, val);
          }
          return true;
        },
      });

      function mapValidationPathParts(part) {
        return part.match(/[0-9]+/) ? `$each.${part}` : part;
      }
    },
    $proxyValidatedModel(modelPath) {
      return deepProxy(get(this, modelPath, {}), {
        get(target, path, receiver) {
          if (typeof path !== 'symbol') {
            const attr = get(target, path);

            if (typeof attr !== 'function' && path !== '__ob__') {
              if (typeof attr === 'object') {
                return this.nest(attr);
              } else if (typeof attr === 'undefined' && path !== '$error' && path !== '$flattenParams') {
                return this.nest({});
              }
            }


            return attr;
          }

          return Reflect.get(target, path, receiver);
        },
      });
    },
    $getErrorMessage(attr) {
      if (attr?.$flattenParams) {
        const error = attr.$flattenParams().find((validation) => {
          const notValid = !attr[validation.name];
          const hasErrorMessage = validation.params.errorMessage;

          return notValid && hasErrorMessage;
        });

        if (error) {
          return error.params.errorMessage;
        }
      }

      return '&nbsp;';
    },
    $getDeepErrors(outerObj, currentKey, path) {
      const obj = outerObj[currentKey];
      return Object.keys(obj).reduce((acc, key) => {
        if (key.charAt(0) === '$' && key !== '$store' && key !== '$each') return acc;
        if (typeof obj[key] === 'object') {
          return acc.concat(this.$getDeepErrors(obj, key, path.concat(key)));
        }
        if (!obj[key]) {
          const allParams = obj.$flattenParams();
          const origin = allParams.find(param => get(param, 'params.origin'));

          acc.push({
            key: currentKey,
            path,
            origin: origin ? origin.params.origin : null,
            error: key,
            errorParams: obj.$params[key],
            errorMessage: this.$resolveErrorMessage(get(obj.$params[key], 'errorMessage', '')),
            allParams,
            getLabel: function() {
              const el
                = document.getElementById(this.path.join('-'))
                || document.getElementById(this.key);

              if (!el) return false;

              const labelEl = el.querySelector('.q-if-label');
              if (!labelEl) return false;

              return labelEl.textContent.replace(' *', '').trim();
            },
          });
        }
        return acc;
      }, []);
    },
    $resolveErrorMessage(message) {
      return typeof message === 'function'
        ? message.call(this)
        : message;
    },
  },
  computed: {
    $allErrors() {
      return this.$getDeepErrors({ $v: this.$v }, '$v', []);
    },
  },
};
